module.exports = __webpack_public_path__ + "img/stock2.b4755ab8.png";